<template>
    <div class="classification">
        <card type="cinc" class="ReCallClass lightTheme"> <!--v-if="objCall.call_record !=''"-->
            <template v-slot:header>
                <div>
                    <div class="row align-items-center">
                        <div class="col">
                            <span class="badge badge-pill badge-warning">Классификация</span>
                            
                            <div class="date"><span>{{$GVO.convertDateTimeFromMysql(objCall.InsertTime)}}</span></div>

                            <div class="note-content" ><p class="description">Кто классифицировал: {{objCall.agent_name}}</p></div>
                            <div class="note-content" ><p class="text-success">Результат классификации: {{objCall.descr}}</p></div>

                            <div class="row mx-0" v-if="objCall.client_id > 0">
                                <p class="description mr-2">Создан клиент: </p>
                                <router-link :to="'/data/clients/id/'+objCall.client_id" class="mr-2">посмотреть клиента</router-link> <p class="description" v-if="objCall.service_id > 0">ID услуги {{objCall.service_id}} </p>
                            </div>
                            <div class="row mx-0" v-if="(objCC.result_descr!='0') && objCC.result_descr!=null">
                                <!-- добавить дату, время и примечание к основному тексту-->
                                <p class="description mr-2">Примечание: {{objCC.result_descr}}</p>
                            </div>
                            <div class="row mx-0" v-if="(objCC.dt_remember!='0000-00-00 00:00:00') && objCC.dt_remember!=null">
                                <!-- добавить дату, время и примечание к основному тексту-->
                                <p class="description mr-2">Перезвонить: {{$GVO.convertDateTimeFromMysql(objCC.dt_remember)}}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <!-- <pre>{{objCall}}</pre>
            <pre>{{objCC}}</pre> -->
        </card>
    </div>
</template>

<script>


export default {
    name: 'ReCallClass',
    components: {

    },
    props: {
        counter: String,
        findId: { //это свойсво удалять не надо, оно хорошее и моет быть использовано в опуиях для формпринтера или фильтрпринтера
            type: String,
            default: '',            
        },
        objCall: {
            type: Object,
            default: function() {
				return {};
			}
        },
        client_id: [String,Number],	
        objCC: {
            type: Object,
            default: function() {
				return {};
			}
        }
  

    },
    data () {
        return {
            ver: 1,   
            getBackDescr: '',
            getBackTime: '',   
            bIsLoading:false,    
            masGetBack: [], 
            objGetBack: {}, 
        }
    },
    computed: {

    },
    methods: {  
        
        
               
    },
    mounted() {
		
	}
}
</script>
<style scoped>

.ReCallClass .date {
    font-size: 12px;
    color: #9A9A9A;
    margin: 5px 0px;
}
.ReCallClass >>> .card-body {padding: 0px 15px 15px 15px;}
.badge-grey {background: #9A9A9A; color: #fff;}
.ReCallClass >>> audio {
    outline: none;
	border-radius: 2rem;
    box-shadow: 0px 0px 10px rgba(1, 176, 224, 0.3);
}
.ReCallClass >>> figure {margin-bottom: 0px;}
.ReCallClass .description{font-size: 14px; color:#9A9A9A;}
.call-audio {
    background-color: transparent;
    border: 1px solid #01B0E0;
    box-shadow: 0px 0px 10px rgba(1, 176, 224, 0.3);
}
.white-content .card:not(.card-white) .lightTheme {border: 1px solid #c4c4c4;}

figure > *{display: inline-block;}
figure > a.a-dwld{
    font-size: 35px;
    vertical-align: top;
    margin-top: 10px;
    margin-left: 20px;
}

@media (max-width: 400px) {
    audio {width: 215px;}
}
@media (max-width: 853px) and (min-width: 768px) {
    audio {width: 230px;}
}

</style>
